import styles from './styles.module.css';
import error from '../../assets/svgs/error.svg';
import { useTranslation } from 'react-i18next';

export function SmallScreenState() {
    const { t } = useTranslation();

    return (
        <div className={styles.errorContainer}>
            <img className={styles.errorImage} alt="Error logo" src={error} />
            <div className={styles.errorTextWrapper}>
                <div className={styles.errorTextTitle}>{t("smallScreenState.contentTitle")}</div>
                <div className={styles.errorTextSubtitle}>{t("smallScreenState.contentSubtitle")}</div>
            </div>
        </div>
    )
}